import { memo } from 'react';
import { Icon } from '../../icon-svg/pc-icon';
import { useConversationTools } from '../hooks/hook';
import { useChatTranslation } from '../hooks/use-i18n';
import { cx } from '../../cx';

export const StopButton = memo(() => {
  const { stopAllChat } = useConversationTools();
  const { t } = useChatTranslation();

  return (
    <div
      className={cx(
        'absolute -top-2 -translate-y-full left-1/2 -translate-x-1/2 bg-white3 shadow-modal-sm px-2.5 py-1 rounded-3xl animate-click space-x-1 flex items-center text-t2-medium'
      )}
      onClick={(e) => {
        e.stopPropagation();
        stopAllChat();
      }}
    >
      <Icon
        name="IcStop"
        className="text-red animate-pulse [animation-duration:700ms]"
        size="small"
      />
      <span>{t('chatStopGenerating')}</span>
    </div>
  );
});
